import Vue from 'vue'
import router from '@/router'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      redirectPath: null
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.enableSave()) {
      this.redirectPath = to.path
      if (this.isAdminRole) {
        this.$refs.saveAlertModal.show()
      } else {
        this.discardData()
      }
    } else {
      next()
    }
  },

  computed: {
    mappingsSaveData () {
      let layers = this.stage.find('Layer').filter(function (layer) {
        return layer.attrs.edit_type === 'created'
      })
      let groups = this.stage.find('Group').filter(function (group) {
        return group.attrs.edit_type === 'created'
      })
      let shapes = this.stage.find('Rect').filter(function (shape) {
        return shape.attrs.edit_type === 'created'
      })

      let mappings = layers.concat(groups, shapes)

      return mappings.map(map => map.attrs)
    },
    ...mapGetters(['isAdminRole'])
  },

  methods: {
    enableSave () {
      return this.currentIndex > 0
    },

    discardData () {
      this.resetEditHistory()
      router.push(this.redirectPath)
    },

    saveData (formStatus, esmPresentStatus, svPresentStatus, cvPresentStatus) {
      let vm = this
      let updateEsmStatus = formStatus
      let esmStatus = esmPresentStatus
      let svStatus = svPresentStatus
      let cvStatus = cvPresentStatus
      let data = new window.FormData()
      let mapData = JSON.stringify(this.mappingsSaveData)
      data.append('mappings', mapData)
      data.append('template_id', this.id)
      data.append('form_status', updateEsmStatus)
      data.append('esm_status', esmStatus)
      data.append('sv_status', svStatus)
      data.append('cv_status', cvStatus)
      this.mappingDataLoaded = false
      this.editorDataLoaded = false
      Vue.axios.post('/template_mappings/save_editor', data, { headers: { Authorization: `Bearer ${vm.idToken}` } })
        .then(response => {
          Vue.toasted.show(response.data.message, { type: response.data.error ? 'error' : 'success' })
          // Vue.toasted.show(this.$t('TEMPLATE.MSG_SAVED'))
          this.resetEditHistory()
          if (this.redirectPath) {
            router.push(this.redirectPath)
          } else {
            this.fetchTemplateWithOutGaurd()
          }
        }, error => {
          Vue.toasted.show(this.$t('TEMPLATE.MSG_SAVE_FAIL'),
            { icon: 'chain-broken', type: 'error' })
          console.log(error)
          this.mappingDataLoaded = true
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/saveEditor.js